<template>
  <div class="wang-editor-container">
    <div class="wang-editor__tool-bar wang-editor__item" ref="toolBar"></div>
    <div class="wang-editor__main-body wang-editor__item" ref="mainBody" v-html="val"></div>
  </div>
</template>

<script>
import E from 'wangeditor';
import { upload } from '@/api/common';
import { parseImage, parseHtml } from '@/filters';

export default {
  name: 'wang-editor',
  props: {
    model: {
      type: String,
      default: null,
    },
    val: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploadUrl: 'http://api.clzx.net/public/admin/Publiccon/upload',
      editorToolBar: [
        // 'head',
        // 'fontSize',
        // 'foreColor',
        // 'backColor',
        'link',
        // 'list',
        'justify',
        // 'quote',
        'image',
        // 'table',
        'undo',
        'redo',
      ],
    };
  },
  watch: {
    val: {
      handler(n) {
        if (this.$editor) {
          console.log(this.$editor.txt.html())
        }
      }
    }
  },
  mounted() {
    const targets = [this.$refs.toolBar, this.$refs.mainBody];
    this.$editor = this.initEditor(targets);
    document.getElementById(this.$editor.imgMenuId).classList.add('customUploadBt');
  },
  methods: {
    initEditor(targets) {
      const editor = new E(...targets);
      editor.customConfig = {
        onchange: (v) => this.editorTextChange(v),
      };
      editor.customConfig.debug = true;
      editor.customConfig.uploadImgServer = this.uploadUrl;
      editor.customConfig.menus = this.editorToolBar;
      editor.customConfig.customUploadImg = this.uploadfiles;
      editor.create();
      return editor;
    },
    editorTextChange(val) {
      const text = val === '<p><br></p>' ? '' : val;
      this.$emit('editorChange', this.model, text, parseHtml(text).length);
      return text;
    },
    async uploadfiles(files, insert) {
      const loading = this.$loading({
        target: this.$refs.mainBody,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        text: '上传中...',
      });
      const res = await upload(files);
      res.forEach((item) => {
        const url = parseImage(item.data.self_url);
        insert(url);
      });
      loading.close();
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/mixin";

.wang-editor-container {
  position: relative;
  z-index: 3;
  width: 100%;
  @include flex-box;
  flex-direction: column;
  // height: 666px;
  min-height: 250px;
  max-height: 600px;

  .wang-editor__item {
    border: 1px solid #e7e7e7;
    width: inherit;
  }

  .wang-editor__tool-bar {
    flex: 0 0 30px;
    position: relative;

    .w-e-menu {
      padding: 0 10px;
    }

    .customUploadBt {
      position: absolute;
      top: 0;
      right: 0;
      @include flex-box;
      background-color: $yellow;
      align-items: center;
      cursor: pointer;

      .w-e-icon-image {
        &::before {
          content: '';
          background: url('~@/assets/images/icon-upload.png') no-repeat center;
          background-size: contain;
          display: inline-block;
          width: 20px;
          height: 20px;
        }
      }

      &::after {
        content: "上传图片";
        font-size: 12px;
        color: #fff;
        margin-left: 10px;
      }
    }
  }

  .wang-editor__main-body {
    flex: 1;
    border-top: 0;
    height: 100%;
    @include flex-box;
    flex-direction: column;
    overflow: hidden;

    .w-e-text {
      flex: 1;
      width: 100%;
      height: 100%;
    }
  }

  .el-loading-mask {
    .el-icon-loading {
      color: $yellow;
    }

    .el-loading-text {
      color: $yellow;
    }
  }
}
</style>
